export const urlRegex =
  // eslint-disable-next-line
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

export const urlRegexWithPrecoding =
  // same with urlRegex, but allows {{snake_case}} (precoding) in the end (optional)
  // eslint-disable-next-line
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)({{([a-z_]+)}})?/;
